var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',{attrs:{"value":_vm.active}},[_c('vs-tab',{attrs:{"label":"Open"}},[_c('Open')],1),_c('vs-tab',{attrs:{"label":"Approved"}},[_c('Approved')],1),_c('vs-tab',{attrs:{"label":"Rejected"}},[_c('Rejected')],1),_c('vs-tab',{attrs:{"label":"Inquiry"}},[_c('Inquiry')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }